const hasAnchorTag = (text) => {
  return text.split('<').some((val) => val.startsWith('a') && val.includes('href='));
};

export default hasAnchorTag;
